import { initCore } from 'src/lib/init.js'
import Inventory from "@/inventory/pages/Inventory.vue"
import renderComponents from 'src/lib/render-components.js'
import InventoryCard from '@/inventory/pages/InventoryCard.vue'

initCore()
renderComponents({
    'inventory': Inventory,
    'inventory-card': InventoryCard,

})
